/**
 * The ⌘K/Ctrl+K shortcut itself already handles every platform (both
 * metaKey and ctrlKey are wired up in SidebarLeft). This only decides
 * which glyph to show for it.
 */
export const IS_MAC =
  typeof navigator !== "undefined" && /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent || "");

export const QUICK_ACTIONS_SHORTCUT_LABEL = IS_MAC ? "⌘K" : "Ctrl+K";
